import React, { useState } from 'react'
import ComponentInView from '@boltui/component-in-view'
import fetch from 'isomorphic-unfetch'

import { gethostPath } from '../../helpers/ContentHelper'
import PromotionPanel from '../PromotionPanel/PromotionPanel'

const WhatsHot = ({ recommendationsData }) => {
  const [data, setData] = useState()
  const [gettingData, nowGettingData] = useState(false)
  const whatsHotData = {
    error: false,
    loading: !data,
    recommendations: recommendationsData.data,
    products: data,
  }

  const fetchData = async () => {
    if (whatsHotData && whatsHotData.recommendations) {
      const partNumbers = whatsHotData.recommendations.map((product) => product.id)
      Promise.all(partNumbers.map((product) => fetch(`${gethostPath()}global-api/products/partNumber=${product}`)))
        .then((groupedResponse) =>
          Promise.all(groupedResponse.map((response) => response.json().then((dataTest) => dataTest.data.data))),
        )
        .then((finalData) => {
          setData(finalData)
        })
        .catch((error) => console.log(error))
    }
  }

  const getWhatsHotData = typeof whatsHotData.products === 'undefined'

  const getData = () => {
    if (!gettingData) {
      nowGettingData(true)
      fetchData()
    }
  }
  return (
    <ComponentInView offsetTop={500} onEnter={() => getWhatsHotData && getData()} onLeave={() => {}}>
      <PromotionPanel
        data={whatsHotData}
        title='Everybody loves these...'
        tracking={{ eventName: 'hp_recommendationsViewed', eventAction: 'Recommendations Viewed' }}
        source={'trending'}
        section={'bottomSlider'}
      />
    </ComponentInView>
  )
}

export default WhatsHot
